import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import { useTranslation } from 'react-i18next';

import {
  makeRowColumn,
  getHeadObj,
  dataConverter,
} from 'lib/commonLib';
import { hologramPopup } from 'lib/api/sales';

import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import NewTableContainer from 'components/molecules/NewTable';

const HologramBannerDetail = ({ location }) => {
  const { t } = useTranslation();
    
  const convertKeys = [
    'adverId',
    'sDate',
    'eDate',
    "feeRate",
    'uri'
  ];
    
  const newInitParams = dataConverter(
    queryString.parse(location.search),
    convertKeys
  );
  
  let initParams = {
    ...newInitParams,
    page: '1',
    limit: '50',
    keyword: '',  
  };
  const [params, setParams] = useState(initParams);
  const [reFetch, setReFetch] = useState(false);
  const [initialization, setInitialization] = useState(false);

  // header 및 body 컬럼 커스텀
  const customized = {
    STATS_DTTM: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'STATS_DTTM');
        let result;
        if (rowObj['STATS_DTTM'] === 'Total') {
          result = t('합계');
        } else {
          result = makeRowColumn(
            rowObj['STATS_DTTM'],
            bodyItem1.type,
            bodyItem1.format,
          );
        }
        return result;
      }
    },
    ADVER_ID: {
      makeBody: (rowObj, headsMap) => {        
        return makeRowColumn(rowObj['ADVER_ID'])
      },
      merged: true
    }
  };
  
  useEffect(() => {
    setInitialization(false);
    setReFetch(false);
  }, [params, reFetch]);


  /**
   * 필터 초기화
   */
   const handleOnReset = () => {
    if (JSON.stringify(params) !== JSON.stringify(initParams)) {
      setInitialization(true);
      setParams(initParams);
    }
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };
  
  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          usePltfomTpCodeFilter={false}
          useDisplayFilter={false}
          useExternalFilter={false}
        />
      </NewFilterWrap>
      <NewTableContainer
        params={params}
        dataReqPromise={hologramPopup}
        getParam={getParam}
        customized={customized}
        isIncludingTotal
        reFetch={reFetch}        
        useTotal={true}
      />
    </>
  );
};

export default withRouter(HologramBannerDetail);
